import { render, staticRenderFns } from "./remotejs.vue?vue&type=template&id=79956f64&"
import script from "./remotejs.vue?vue&type=script&lang=js&"
export * from "./remotejs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports